export default "__VITE_ASSET__DlUbumu4__"